import { render, staticRenderFns } from "./SystemConfigs.vue?vue&type=template&id=74be9dcc&scoped=true"
import script from "./SystemConfigs.vue?vue&type=script&lang=js"
export * from "./SystemConfigs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74be9dcc",
  null
  
)

export default component.exports